import { MapPin, ChevronDown } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useNavigate } from "react-router-dom";
import { useUserLocation } from "@/hooks/useUserLocation";

export const AppHeader = () => {
  const { user, profile, signOut } = useAuth();
  const navigate = useNavigate();
  const { location, isLoading } = useUserLocation();

  const handleSignOut = async () => {
    await signOut();
    navigate("/");
  };

  const initials = profile?.name
    ? profile.name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2)
    : "U";

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-sm border-b border-border safe-area-pt">
      <div className="flex items-center justify-between h-14 px-4">
        {/* Location */}
        <button className="flex items-center gap-1.5 text-left touch-manipulation">
          <MapPin className="w-4 h-4 text-primary" />
          <div className="flex flex-col">
            <span className="text-sm font-medium text-foreground leading-tight">
              {isLoading ? "Detecting..." : location?.suburb || "Set location"}
            </span>
            {location?.city && (
              <span className="text-[10px] text-muted-foreground leading-tight">
                {location.city}
              </span>
            )}
          </div>
          <ChevronDown className="w-3.5 h-3.5 text-muted-foreground" />
        </button>

        {/* Profile Avatar */}
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="touch-manipulation">
              <Avatar className="h-8 w-8">
                <AvatarImage src={profile?.profile_photo || undefined} />
                <AvatarFallback className="bg-primary/10 text-primary text-xs">
                  {initials}
                </AvatarFallback>
              </Avatar>
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-48">
            <DropdownMenuItem onClick={() => navigate("/app/profile")}>
              Profile
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => navigate("/customer/settings")}>
              Settings
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={handleSignOut}>
              Sign out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
};
